import { INPUT_MSG } from "@/consts/message";

interface IProps {
    isPinCheckFailed: boolean;
    isNotMatchPin?: boolean;
    pinStep?: 'CHECK' | 'NEW' | 'CONFIRM';
}

const PinGuideTextArea = ({isPinCheckFailed, isNotMatchPin, pinStep}: IProps) => {
    return (
        <div className="txt-area">
            {pinStep === 'CHECK' && (
                <p className="body-s-n fw-b">{isPinCheckFailed ? INPUT_MSG.PIN_CHECK_FAILED : ''}</p>
            )}
            {pinStep === 'NEW' && (
                <p className="body-s-n fw-b">{''}</p>
            )}
            {pinStep === 'CONFIRM' && (
                <p className="body-s-n fw-b">{isNotMatchPin ? "비밀번호가 일치하지 않습니다." : ''}</p>
            )}
        </div>
    )
}

export default PinGuideTextArea;